<template>
  <div
    ref="kt_modal_pdv_qtd"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_pdv_qtd"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Quantidade</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div
            class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row"
          >
            <label class="form-label">Quantidade</label>
            <div class="input-group mb-2">
              <CurrencyInput
                id="txtQtd"
                class="form-control fs-1 text-danger"
                placeholder="Quantidade"
                style="text-align: right"
                v-model="this.qtd"
                :options="optionsQtd"
                :class="[
                  'form-control',
                  errosValidacao['qtd'] ? 'is-invalid' : '',
                ]"
                @keydown="eventQtd"
              ></CurrencyInput>
              <button
                id="btnAdicionar"
                class="input-group-text"
                @click="this.qtd++"
              >
                <span class="svg-icon svg-icon-2hx">
                  <inline-svg src="media/icons/duotune/general/gen041.svg" />
                </span>
              </button>
              <button
                id="btnRemover"
                class="input-group-text"
                @click="this.qtd - 1 <= 0 ? (this.qtd = 1) : this.qtd--"
              >
                <span class="svg-icon svg-icon-2hx">
                  <inline-svg src="media/icons/duotune/general/gen042.svg" />
                </span>
              </button>
            </div>

            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["qtd"] }}
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import CurrencyInput from "@/components/text/CurrencyInput";
export default {
  components: { CurrencyInput },
  emits: ["exibirModalEditarQuantidade", "confirmarModalEditarQuantidade"],
  props: {
    qtdAtual: { type: Number, required: true, default: 1 },
  },
  methods: {
    confirmar() {
      if (!this.qtd || isNaN(this.qtd) || this.qtd <= 0) {
        this.errosValidacao["qtd"] =
          "A quantidade deve ser um número válido e maior que zero.";
        return;
      } else {
        this.errosValidacao["qtd"] = "";
      }

      this.loading = true;
      this.$emit("confirmarModalEditarQuantidade", this.qtd);
      hideModal(this.$refs.kt_modal_pdv_qtd);
      this.$emit("exibirModalEditarQuantidade", false);
      this.loading = false;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_pdv_qtd);
      this.$emit("exibirModalEditarQuantidade", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    eventQtd(event) {
      if (event.key === "+" || event.key === "=" || event.key === "ArrowUp") {
        event.preventDefault();
        event.stopPropagation();
        this.qtd++;
      } else if (event.key === "-" || event.key === "ArrowDown") {
        event.preventDefault();
        event.stopPropagation();
        this.qtd - 1 <= 0 ? (this.qtd = 1) : this.qtd--;
      } else if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        this.confirmar();
      } else if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        this.cancelar();
      }
    },
  },
  mounted() {
    this.qtd = this.qtdAtual;
    this.$utils.requestFocus("txtQtd");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      qtd: 1,
      optionsQtd: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: [0, 1, 2, 3, 4],
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
